import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

interface ImageDarkOverlayProps {
  label: string;
}

export default function ImageDarkOverlay({ label }: ImageDarkOverlayProps): React.JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.65)',
        height: '100%',
        width: '100%',
        position: 'absolute',
        zIndex: 5,
        borderRadius: 'inherit',
        overflow: 'hidden',
      }}
    >
      <Typography
        variant={isMobile ? 'titleSmall' : 'titleMedium'}
        color="inverseOnSurface"
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          px: 4,
          boxSizing: 'border-box',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
